import { Component, OnDestroy, OnInit } from "@angular/core";
import { APIService } from "../../../api/api.service";
import { NotifierService } from "./../../../_services/notifier.service";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

interface SecurityGroupRuleEditorRow {
  id: string;
  protocol: string;
  from_port: number | null;
  to_port: number | null;
  target_type: "cidr_ipv4" | "cidr_ipv6" | "referenced_group_ids" | "prefix_list_ids";
  target_value: string;
  isNew: boolean;
}

@Component({
  //moduleId: module.id.toString(),
  templateUrl: "./sg.operations.component.html",
  styleUrls: ["./sg.operations.component.css"],
})
export class sgOperationsComponent implements OnInit, OnDestroy {
  userId = localStorage.getItem("eId");
  ut = localStorage.getItem("ut");
  urlPrefix: string = ((localStorage.getItem("role") || "").toLowerCase() == "admin"
    ? "admin"
    : "client");
  apiBaseUrl: string = environment.apiURL || APIService.API_ENDPOINTV3;
  writeAccess: boolean =
    localStorage.getItem("acT") == "readandwrite" ||
    this.urlPrefix == "admin" ||
    localStorage.getItem("ut") == "admin";
  loading = true;
  sgTabs: any = [];
  sgList: any = [];
  rulesModalOpen = false;
  rulesActiveTab: "inbound" | "outbound" = "inbound";
  rulesLoading = false;
  rulesSaving = false;
  rulesSubmitAttempted = false;
  rulesFetchSupported = true;
  selectedSecurityGroup: any = null;
  inboundRules: SecurityGroupRuleEditorRow[] = [];
  outboundRules: SecurityGroupRuleEditorRow[] = [];
  revokeInboundRules: SecurityGroupRuleEditorRow[] = [];
  revokeOutboundRules: SecurityGroupRuleEditorRow[] = [];

  accountId = localStorage.getItem("accountId");
  regionId = localStorage.getItem("regionId");
  currentMessage: any;
  currentTabClickId: string = "";

  funRef: any;

  headers: any = [
    {
      id: "sg_name",
      name: "Security Group Name",
      click: "loadAttachedInstances",
      filter: true,
    },
    {
      id: "sg_id",
      name: "Security Group ID",
      filter: true,
    },
    {
      id: "instance_attched",
      name: "Instances(EC2/RDS)",
    },
  ];

  attachedInstances: any;
  attachedInstancesHeader: any = [
    {
      id: "instance_name",
      name: "Instance Name",
    },
    {
      id: "instance_id",
      name: "Instance ID",
    },
    {
      id: "service",
      name: "Service",
    },
  ];

  constructor(
    private apiServer: APIService,
    public notifier: NotifierService,
    private http: HttpClient
  ) {}
  ngOnInit(): void {
    this.accountId = localStorage.getItem("accountId");
    this.regionId = localStorage.getItem("regionId");

    //this.load();
    this.currentMessage = this.notifier.currentMessage.subscribe((msg) => {
      let d = JSON.parse(msg);
      if (d.value == null) {
        return;
      }

      if (d.key == "accountId") {
        this.accountId = d.value;
        this.load();
      } else if (d.key == "regionId") {
        this.regionId = d.value;
        this.load();
      }
    });

    this.funRef = {
      loadAttachedInstances: this.loadAttachedInstances,
    };
  }

  ngOnDestroy(): void {
    this.currentMessage.unsubscribe();
  }

  createJobTrigger: boolean = false;

  createJob(event: any) {
    this.createJobTrigger = true;
  }

  hideCreateJob(event: any) {
    if (event) {
      this.load();
    }
    this.createJobTrigger = null;
  }

  jobProgress: string = null;
  async load(loader: boolean = true) {
    if (loader) {
      this.notifier.loading(true);
    }
    let data = {
      action: "sg_summary",
      region_name: this.regionId,
      account_id: this.accountId,
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    //https://api.swayam.cloud/v3/admin/support
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/compliance/sg`;

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    this.sgTabs = [];
    if (result.status == "1" && !result.error_message) {
      this.jobProgress = result["job_status"];
      if (result["job_status"] == "In Progress") {
        this.notifier.loading(false);
        setTimeout(() => {
          this.load(false);
        }, 5000);
        return;
      }
      result["total_sg"]["metadata"] = {
        str: `<strong>Total SG</strong> ${result["total_sg"]["count"]}`,
        id_str: "#" + result["total_sg"]["onclick"],
      };
      result["attached_sg"]["metadata"] = {
        str: `<strong>Attached SG</strong> ${Number(
          result["attached_sg"]["count"]
        )} (${
          result["attached_sg"] && Number(result["attached_sg"]["count"])
            ? (
                (Number(result["attached_sg"]["count"]) /
                  result["total_sg"]["count"]) *
                100
              ).toFixed(2)
            : 0
        }%)`,
        id_str: "#" + result["attached_sg"]["onclick"],
      };
      result["unattached_sg"]["metadata"] = {
        str: `<strong>Unattached SG</strong> ${Number(
          result["unattached_sg"]["count"]
        )} (${
          result["unattached_sg"] && Number(result["unattached_sg"]["count"])
            ? (
                (Number(result["unattached_sg"]["count"]) /
                  result["total_sg"]["count"]) *
                100
              ).toFixed(2)
            : 0
        }%)`,
        id_str: "#" + result["unattached_sg"]["onclick"],
      };
      this.sgTabs.push(result["total_sg"]);
      this.sgTabs.push(result["attached_sg"]);
      this.sgTabs.push(result["unattached_sg"]);
      if (this.sgTabs.length > 0) {
        this.getSecurityGroups(this.sgTabs[0].onclick);
      } else {
        this.notifier.loading(false);
      }
    } else {
      this.notifier.alert("Info", "", result.error, "info", 5000);
      this.notifier.loading(false);
    }
  }

  async getSecurityGroups(clickID: String) {
    this.currentTabClickId = (clickID || "").toString();
    this.notifier.loading(true);
    let data = {
      action: clickID,
      region_name: this.regionId,
      account_id: this.accountId,
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    //https://api.swayam.cloud/v3/admin/support
    let apiURL = `${APIService.API_ENDPOINTV3}/${this.urlPrefix}/compliance/sg`;

    let result = await this.apiServer.postDataPromis(apiURL, data, header);

    if ((result.status == "1" || result.s == "1") && result[`${clickID}`]) {
      this.sgList = result[`${clickID}`];
    } else {
      this.notifier.alert("Info", "", result.error, "info", 5000);
    }

    this.notifier.loading(false);
  }

  async loadAttachedInstances(ref: any, param: any) {
    if (param.showNested) {
      param["showNested"] = false;
      return;
    }
    if (Number(param.instance_attched) == 0) {
      ref.notifier.alert(
        "Info",
        "",
        "No Attached Instances Found",
        "info",
        5000
      );
      return;
    }
    ref.notifier.loading(true);
    let data = {
      action:
        param.onclick == "attached_instances"
          ? "attched_instances"
          : param.onclick,
      region_name: ref.regionId,
      account_id: ref.accountId,
      sg_id: param.sg_id,
    };

    let header = {
      Authorization: localStorage.getItem("t"),
    };
    //https://api.swayam.cloud/v3/admin/support
    let apiURL = `${APIService.API_ENDPOINTV3}/${ref.urlPrefix}/compliance/sg`;

    let result = await ref.apiServer.postDataPromis(apiURL, data, header);
    if (result.status == "1" || result.s == "1") {
      //this.attachedInstances = result.instance_details;
      param.attachedInstances = result.instance_details;
      param.showNested = true;
    } else {
      ref.notifier.alert("Info", "", result.error, "info", 5000);
    }

    ref.notifier.loading(false);
  }

  hideNested(e: any) {
    console.log("hideNested", e);
    //this.showOffendesModal = false;
    //this.offendeList = [];
  }

  callFunction(name: any, param: any) {
    this.funRef[name](this, param);
  }

  private authHeaders() {
    return { Authorization: localStorage.getItem("t") };
  }

  private putHeaders() {
    let headers = new HttpHeaders().set(
      "Content-Type",
      "application/json; charset=utf-8"
    );
    const token = localStorage.getItem("t");
    if (token) {
      headers = headers.set("Authorization", token);
    }
    return headers;
  }

  private buildApiUrl(path: string) {
    return `${this.apiBaseUrl}/${this.urlPrefix}/${path}`;
  }

  private createRuleRow(
    partial: Partial<SecurityGroupRuleEditorRow> = {}
  ): SecurityGroupRuleEditorRow {
    return {
      id: partial.id || `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`,
      protocol: partial.protocol || "tcp",
      from_port: partial.from_port ?? 22,
      to_port: partial.to_port ?? 22,
      target_type: partial.target_type || "cidr_ipv4",
      target_value: partial.target_value || "",
      isNew: partial.isNew ?? true,
    };
  }

  private cloneRuleRow(row: SecurityGroupRuleEditorRow): SecurityGroupRuleEditorRow {
    return this.createRuleRow({
      ...row,
      id: `${row.id}-clone-${Math.random().toString(36).slice(2, 8)}`,
    });
  }

  private getRulesFetchPath(groupId: string) {
    return this.buildApiUrl(
      `apis/ec2-get-master-data/security-groups/${groupId}/rules?account_id=${this.accountId}&region=${this.regionId}`
    );
  }

  private getRulesUpdatePath(groupId: string) {
    return this.buildApiUrl(`apis/ec2-get-master-data/security-groups/${groupId}/rules`);
  }

  private async getSecurityGroupRules(groupId: string) {
    try {
      const response = await this.apiServer.getDataPromis(
        this.getRulesFetchPath(groupId),
        {},
        this.authHeaders()
      );
      if (!response || typeof response == "string") {
        return null;
      }
      return response;
    } catch {
      return null;
    }
  }

  private async putSecurityGroupRules(groupId: string, body: any) {
    try {
      return await this.http
        .put(this.getRulesUpdatePath(groupId), body, { headers: this.putHeaders() })
        .toPromise();
    } catch (error: any) {
      return error?.error || null;
    }
  }

  private getCandidateRuleCollections(response: any, direction: "inbound" | "outbound") {
    if (!response) {
      return [];
    }

    const inboundCandidates = [
      response?.inbound_rules,
      response?.ingress_rules,
      response?.ip_permissions,
      response?.security_group_rules?.inbound,
      response?.data?.inbound_rules,
      response?.data?.ingress_rules,
      response?.items?.inbound_rules,
    ];

    const outboundCandidates = [
      response?.outbound_rules,
      response?.egress_rules,
      response?.ip_permissions_egress,
      response?.security_group_rules?.outbound,
      response?.data?.outbound_rules,
      response?.data?.egress_rules,
      response?.items?.outbound_rules,
    ];

    return (direction === "inbound" ? inboundCandidates : outboundCandidates).find((item) =>
      Array.isArray(item)
    );
  }

  private normalizeLoadedRuleRows(
    response: any,
    direction: "inbound" | "outbound"
  ): SecurityGroupRuleEditorRow[] {
    const rules = this.getCandidateRuleCollections(response, direction);
    if (!Array.isArray(rules)) {
      return [];
    }

    const normalizedRows: SecurityGroupRuleEditorRow[] = [];

    rules.forEach((rule: any, ruleIndex: number) => {
      const protocol = (rule?.ip_protocol ?? rule?.IpProtocol ?? "tcp").toString();
      const fromPort =
        rule?.from_port ?? rule?.FromPort ?? rule?.fromPort ?? (protocol === "-1" ? null : 22);
      const toPort =
        rule?.to_port ?? rule?.ToPort ?? rule?.toPort ?? (protocol === "-1" ? null : fromPort);

      const sources = [
        ...(Array.isArray(rule?.cidr_ipv4) ? rule.cidr_ipv4.map((value: string) => ({ type: "cidr_ipv4", value })) : []),
        ...(Array.isArray(rule?.cidr_ipv6) ? rule.cidr_ipv6.map((value: string) => ({ type: "cidr_ipv6", value })) : []),
        ...(Array.isArray(rule?.prefix_list_ids)
          ? rule.prefix_list_ids.map((value: string) => ({ type: "prefix_list_ids", value }))
          : []),
        ...(Array.isArray(rule?.referenced_group_ids)
          ? rule.referenced_group_ids.map((value: string) => ({ type: "referenced_group_ids", value }))
          : []),
      ];

      if (!sources.length) {
        normalizedRows.push(
          this.createRuleRow({
            id: `${direction}-${ruleIndex}`,
            protocol,
            from_port: fromPort == null ? null : Number(fromPort),
            to_port: toPort == null ? null : Number(toPort),
            target_type: "cidr_ipv4",
            target_value: "",
            isNew: false,
          })
        );
        return;
      }

      sources.forEach((source: any, sourceIndex: number) => {
        normalizedRows.push(
          this.createRuleRow({
            id: `${direction}-${ruleIndex}-${sourceIndex}`,
            protocol,
            from_port: fromPort == null ? null : Number(fromPort),
            to_port: toPort == null ? null : Number(toPort),
            target_type: source.type,
            target_value: (source.value || "").toString(),
            isNew: false,
          })
        );
      });
    });

    return normalizedRows;
  }

  openRulesModal(securityGroup: any, defaultTab: "inbound" | "outbound" = "inbound") {
    this.selectedSecurityGroup = securityGroup;
    this.rulesActiveTab = defaultTab;
    this.rulesModalOpen = true;
    this.rulesSubmitAttempted = false;
    this.rulesFetchSupported = true;
    this.inboundRules = [];
    this.outboundRules = [];
    this.revokeInboundRules = [];
    this.revokeOutboundRules = [];
    this.loadRulesForSelectedSecurityGroup();
  }

  closeRulesModal() {
    if (this.rulesSaving) {
      return;
    }
    this.rulesModalOpen = false;
    this.rulesSubmitAttempted = false;
    this.rulesLoading = false;
    this.rulesSaving = false;
    this.selectedSecurityGroup = null;
    this.inboundRules = [];
    this.outboundRules = [];
    this.revokeInboundRules = [];
    this.revokeOutboundRules = [];
  }

  async loadRulesForSelectedSecurityGroup() {
    if (!this.selectedSecurityGroup?.sg_id) {
      return;
    }

    this.rulesLoading = true;
    const response = await this.getSecurityGroupRules(this.selectedSecurityGroup.sg_id);
    this.rulesLoading = false;

    if (!response || response?.error) {
      this.rulesFetchSupported = false;
      this.inboundRules = [];
      this.outboundRules = [];
      this.notifier.alert(
        "Warning",
        "",
        response?.error ||
          "Security group rules could not be loaded. You can still add or revoke rules manually.",
        "warning",
        5000
      );
      return;
    }

    this.inboundRules = this.normalizeLoadedRuleRows(response, "inbound");
    this.outboundRules = this.normalizeLoadedRuleRows(response, "outbound");
  }

  setRulesTab(tab: "inbound" | "outbound") {
    this.rulesActiveTab = tab;
  }

  addRule(direction: "inbound" | "outbound") {
    const nextRow = this.createRuleRow();
    if (direction === "inbound") {
      this.inboundRules = [...this.inboundRules, nextRow];
      return;
    }
    this.outboundRules = [...this.outboundRules, nextRow];
  }

  removeRule(direction: "inbound" | "outbound", row: SecurityGroupRuleEditorRow) {
    if (direction === "inbound") {
      this.inboundRules = this.inboundRules.filter((item) => item.id !== row.id);
      if (!row.isNew) {
        this.revokeInboundRules = [...this.revokeInboundRules, this.cloneRuleRow(row)];
      }
      return;
    }

    this.outboundRules = this.outboundRules.filter((item) => item.id !== row.id);
    if (!row.isNew) {
      this.revokeOutboundRules = [...this.revokeOutboundRules, this.cloneRuleRow(row)];
    }
  }

  undoRemoveRule(direction: "inbound" | "outbound", row: SecurityGroupRuleEditorRow) {
    if (direction === "inbound") {
      this.revokeInboundRules = this.revokeInboundRules.filter((item) => item.id !== row.id);
      this.inboundRules = [...this.inboundRules, { ...row, isNew: false }];
      return;
    }

    this.revokeOutboundRules = this.revokeOutboundRules.filter((item) => item.id !== row.id);
    this.outboundRules = [...this.outboundRules, { ...row, isNew: false }];
  }

  usesPortRange(protocol: string): boolean {
    return !["-1", "icmp", "icmpv6"].includes((protocol || "").toLowerCase());
  }

  isValidPort(value: any): boolean {
    if (value === null || value === undefined || value === "") {
      return false;
    }
    const numericValue = Number(value);
    return Number.isInteger(numericValue) && numericValue >= 0 && numericValue <= 65535;
  }

  isValidCidr(value: string, type: "cidr_ipv4" | "cidr_ipv6") {
    const normalizedValue = (value || "").toString().trim();
    if (!normalizedValue) {
      return false;
    }

    if (type === "cidr_ipv4") {
      return /^(25[0-5]|2[0-4]\d|1?\d?\d)(\.(25[0-5]|2[0-4]\d|1?\d?\d)){3}\/([0-9]|[1-2]\d|3[0-2])$/.test(
        normalizedValue
      );
    }

    return /^[0-9a-fA-F:]+\/([0-9]|[1-9]\d|1[01]\d|12[0-8])$/.test(normalizedValue);
  }

  isValidSecurityGroupReference(value: string) {
    return /^sg-[a-zA-Z0-9]+$/.test((value || "").toString().trim());
  }

  isValidPrefixList(value: string) {
    return /^pl-[a-zA-Z0-9]+$/.test((value || "").toString().trim());
  }

  isRuleRowValid(row: SecurityGroupRuleEditorRow): boolean {
    const protocol = (row.protocol || "").toString().trim().toLowerCase();
    if (!protocol) {
      return false;
    }

    if (this.usesPortRange(protocol)) {
      if (!this.isValidPort(row.from_port) || !this.isValidPort(row.to_port)) {
        return false;
      }
      if (Number(row.from_port) > Number(row.to_port)) {
        return false;
      }
    }

    if (row.target_type === "cidr_ipv4" || row.target_type === "cidr_ipv6") {
      return this.isValidCidr(row.target_value, row.target_type);
    }
    if (row.target_type === "referenced_group_ids") {
      return this.isValidSecurityGroupReference(row.target_value);
    }
    return this.isValidPrefixList(row.target_value);
  }

  getRuleValidationMessage(row: SecurityGroupRuleEditorRow): string {
    const protocol = (row.protocol || "").toString().trim().toLowerCase();
    if (!protocol) {
      return "Protocol is required.";
    }
    if (this.usesPortRange(protocol)) {
      if (!this.isValidPort(row.from_port) || !this.isValidPort(row.to_port)) {
        return "Enter a valid port range between 0 and 65535.";
      }
      if (Number(row.from_port) > Number(row.to_port)) {
        return "From port cannot be greater than to port.";
      }
    }
    if (row.target_type === "cidr_ipv4" && !this.isValidCidr(row.target_value, "cidr_ipv4")) {
      return "Enter a valid IPv4 CIDR block.";
    }
    if (row.target_type === "cidr_ipv6" && !this.isValidCidr(row.target_value, "cidr_ipv6")) {
      return "Enter a valid IPv6 CIDR block.";
    }
    if (
      row.target_type === "referenced_group_ids" &&
      !this.isValidSecurityGroupReference(row.target_value)
    ) {
      return "Enter a valid security group id like sg-1234567890.";
    }
    if (row.target_type === "prefix_list_ids" && !this.isValidPrefixList(row.target_value)) {
      return "Enter a valid prefix list id like pl-1234567890.";
    }
    return "";
  }

  hasInvalidRules(direction: "inbound" | "outbound"): boolean {
    const rows = direction === "inbound" ? this.inboundRules : this.outboundRules;
    return rows.some((row) => row.isNew && !this.isRuleRowValid(row));
  }

  private serializeRuleRow(row: SecurityGroupRuleEditorRow) {
    const normalizedProtocol = (row.protocol || "").toString().trim().toLowerCase();
    const normalizedTargetValue = (row.target_value || "").toString().trim();
    const payload: any = {
      ip_protocol: normalizedProtocol,
      cidr_ipv4: row.target_type === "cidr_ipv4" ? [normalizedTargetValue] : [],
      cidr_ipv6: row.target_type === "cidr_ipv6" ? [normalizedTargetValue] : [],
      prefix_list_ids: row.target_type === "prefix_list_ids" ? [normalizedTargetValue] : [],
      referenced_group_ids:
        row.target_type === "referenced_group_ids" ? [normalizedTargetValue] : [],
    };

    if (this.usesPortRange(normalizedProtocol)) {
      payload.from_port = Number(row.from_port);
      payload.to_port = Number(row.to_port);
    }

    return payload;
  }

  private buildRulesUpdatePayload() {
    return {
      account_id: this.accountId,
      region: this.regionId,
      authorize_ingress: this.inboundRules
        .filter((row) => row.isNew)
        .map((row) => this.serializeRuleRow(row)),
      revoke_ingress: this.revokeInboundRules.map((row) => this.serializeRuleRow(row)),
      authorize_egress: this.outboundRules
        .filter((row) => row.isNew)
        .map((row) => this.serializeRuleRow(row)),
      revoke_egress: this.revokeOutboundRules.map((row) => this.serializeRuleRow(row)),
    };
  }

  hasRuleChanges(): boolean {
    return !!(
      this.inboundRules.some((row) => row.isNew) ||
      this.outboundRules.some((row) => row.isNew) ||
      this.revokeInboundRules.length ||
      this.revokeOutboundRules.length
    );
  }

  canSaveRules(): boolean {
    return !!(
      this.selectedSecurityGroup?.sg_id &&
      this.hasRuleChanges() &&
      !this.hasInvalidRules("inbound") &&
      !this.hasInvalidRules("outbound") &&
      !this.rulesSaving
    );
  }

  async saveRules() {
    this.rulesSubmitAttempted = true;
    if (!this.canSaveRules()) {
      this.notifier.alert(
        "Warning",
        "",
        "Please fix the rule validation errors before saving.",
        "warning",
        4000
      );
      return;
    }

    this.rulesSaving = true;
    const result = await this.putSecurityGroupRules(
      this.selectedSecurityGroup.sg_id,
      this.buildRulesUpdatePayload()
    );
    this.rulesSaving = false;

    if (!(result?.status == "1" || result?.s == "1" || result?.group_id)) {
      this.notifier.alert(
        "Error",
        "",
        result?.error || result?.message || result?.msg || "Unable to update security group rules.",
        "error",
        5000
      );
      return;
    }

    this.notifier.alert(
      "Success",
      "",
      result?.message || result?.msg || "Security group rules updated successfully.",
      "success",
      4000
    );

    await this.loadRulesForSelectedSecurityGroup();
    if (this.currentTabClickId) {
      await this.getSecurityGroups(this.currentTabClickId);
    }
    this.rulesSubmitAttempted = false;
    this.revokeInboundRules = [];
    this.revokeOutboundRules = [];
  }
}
